import { get } from "radash";
import { z } from "zod";

export const multiSelectResponseSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
});

export const responseDetailSchema = z.object({
  response: z.boolean(),
  description: z.string().optional(),
});

/**
 * Helper function to normalize error access for both direct and nested error structures
 * This handles the difference between:
 * - MultiSelect: { message: "...", type: "...", ref: {...} }
 * - MultiSelectResponse: { root: { message: "...", type: "...", ref: {...} } }
 */
export const getFormErrorMessage = (formState: any, fieldName: string): string | undefined => {
  const errorObj = get(formState.errors, fieldName);
  if (!errorObj || typeof errorObj !== "object") return undefined;

  const typedErrorObj = errorObj as { message?: string; root?: { message?: string } };

  // Handle nested error structure (like MultiSelectResponse)
  if (typedErrorObj.root && typeof typedErrorObj.root === "object" && typedErrorObj.root.message) {
    return typedErrorObj.root.message;
  }

  // Handle direct error structure (like MultiSelect)
  if (typedErrorObj.message) {
    return typedErrorObj.message;
  }

  return undefined;
};
